import dayjs from "dayjs";
import {
  maxHoursPerDay,
  maxHoursPerMonth,
  maxHoursPerWeek,
  minutesInHour,
} from "./../constants";
import { OccupancyData, TimeUnits } from "./../types/global";
import { calculateBusinessDays } from "./dates";

export const getTimeOccupancy = (
  timeUnits: TimeUnits,
  zoom: number,
  focusedDate?: dayjs.Dayjs,
  dismissedDate?: string | null
): Omit<
  OccupancyData,
  "taken" | "allocation" | "allocationGroup" | "unavailability" | "projection"
> => {
  let maxHours = maxHoursPerDay;
  switch (zoom) {
    case 0:
    case 3:
      maxHours = maxHoursPerWeek;
      break;
    case 1:
      maxHours = maxHoursPerDay;
      break;
    case 4:
      if (dismissedDate && focusedDate) {
        const dismissed = dayjs(dismissedDate);
        const monthStart = focusedDate.startOf("month");
        const monthEnd = focusedDate.endOf("month");
        if (dismissed.isBefore(monthEnd, "day") && dismissed.isAfter(monthStart, "day")) {
          const activeDays = calculateBusinessDays(monthStart, dismissed);
          const totalDays = calculateBusinessDays(monthStart, monthEnd);
          maxHours = totalDays > 0
            ? Math.round((activeDays / totalDays) * maxHoursPerMonth)
            : maxHoursPerMonth;
        } else {
          maxHours = maxHoursPerMonth;
        }
      } else {
        maxHours = maxHoursPerMonth;
      }
      break;
    case 2:
      maxHours = 1;
      break;
  }

  const getFreeTime = () => {
    let hours = maxHours - timeUnits.hours - 1;
    let minutes = minutesInHour - timeUnits.minutes;

    if (minutes === minutesInHour) {
      hours++;
      minutes = 0;
    }
    return { hours: Math.max(0, hours), minutes: hours < 0 ? 0 : minutes };
  };

  const getOverTime = () => {
    const overHours = timeUnits.hours - maxHours;
    const overMinutes = timeUnits.minutes;
    return {
      hours: Math.max(0, overHours),
      minutes: overHours < 0 ? 0 : overMinutes,
    };
  };

  return {
    free: getFreeTime(),
    overtime: getOverTime(),
  };
};
